// **********************************************************
// Accordion
// **********************************************************

attachEvent('.accordion__title', 'click', (ev) => {
  const title = ev.target.closest('.accordion__title');
  const parentElem = title.closest('.accordion');
  const accordionContent = parentElem.querySelector('.accordion__content');
  const isOpen = parentElem.classList.toggle('is-open');
  title.setAttribute('aria-expanded', isOpen);
  slideToggle(accordionContent, 300, 'block');
});
